import type { QuickReplyItem } from './quickReplyItem';

export function filterQuickReplies<T extends QuickReplyItem>(replies: T[], query: string): T[] {
    const needle = query.trim().toLowerCase();
    if (!needle) return replies;
    return replies.filter((reply) =>
        [reply.code ?? '', reply.title, reply.content].some((field) =>
            field.toLowerCase().includes(needle)
        )
    );
}
